import { Breadcrumb, Modal, Typography, message, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../../hooks/useAuth";
import { registrationApi } from "../../../../api/registrationApi";
import {
  useCheckIn,
  useEventRegistrations,
} from "../../../../hooks/useRegistration";
import { useEvent } from "../../../../hooks/useEvent";
import { EventAttendanceFilter } from "../components/EventAttendanceFilter";
import { EventAttendanceList } from "../components/EventAttendanceList";
import { AddUserToEventModal } from "../components/AddUserToEventModal";

const { confirm } = Modal;
const { Title } = Typography;

export function EventAttendance() {
  const { id: eventId } = useParams();
  const [filter, setFilter] = useState({ page: 1, limit: 10 });
  const { data: event } = useEvent(eventId);
  const {
    data: registrations,
    pagination,
    loading,
    refetch,
  } = useEventRegistrations(eventId, filter);
  const { data: user } = useAuth();

  const { checkInManual, updateStatus, deleteRegistration, updateIsTakingRefuge, adminAddUserToEvent } = useCheckIn();

  const [addUserModalOpen, setAddUserModalOpen] = useState(false);

  const handleCheckIn = (registration) => {
    confirm({
      title: "Xác nhận điểm danh",
      content: `Xác nhận điểm danh cho ${registration.user.name}?`,
      onOk: async () => {
        try {
          await checkInManual.mutateAsync(registration._id);
          message.success("Điểm danh thành công!");
        } catch (error) {
          message.error("Điểm danh thất bại!");
        }
      },
    });
  };

  const handleStatusChange = async (registrationId, newStatus) => {
    try {
      await updateStatus.mutateAsync({ id: registrationId, status: newStatus });
      message.success("Cập nhật trạng thái thành công!");
    } catch (error) {
      message.error(`${error}` || "Cập nhật trạng thái thất bại!");
    }
  };

  const handleUpdateRegistrationCode = async (registrationId, newCode) => {
    try {
      await registrationApi.updateRegistrationCode(registrationId, {
        registrationCode: newCode,
      });
      message.success("Đã cập nhật mã tham dự");
      refetch();
    } catch (err) {
      message.error(
        err?.response?.data?.message || "Cập nhật mã tham dự thất bại"
      );
    }
  };

  const handleTakingRefugeChange = async (registrationId, isTakingRefuge) => {
    try {
      await updateIsTakingRefuge.mutateAsync({ id: registrationId, isTakingRefuge });
      message.success("Cập nhật trạng thái tị nạn thành công!");
    } catch (error) {
      message.error("Cập nhật trạng thái tị nạn thất bại!");
    }
  };

  const handleDelete = async (registrationId) => {
    try {
      await deleteRegistration.mutateAsync(registrationId);
      message.success("Xóa đăng ký thành công!");
    } catch (error) {
      message.error("Xóa đăng ký thất bại!");
    }
  };

  const handleTableChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
    });
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <div>
          <Breadcrumb
            items={[
              { title: "Bảng điều khiển" },
              { title: "Sự kiện", href: "/bang-dieu-khien/su-kien" },
              { title: "Quản lý sự kiện" },
            ]}
          />
          <Title level={3} style={{ margin: 0 }}>
            Danh sách tham gia sự kiện
          </Title>
          <p style={{ margin: "8px 0 0 0", color: "#666" }}>
            Tổng số: {pagination.total} người
          </p>
        </div>

        {user?.role === "admin" && (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setAddUserModalOpen(true)}
            style={{ backgroundColor: "#1890ff", borderColor: "#1890ff" }}
          >
            Thêm người dùng
          </Button>
        )}
      </div>

      <EventAttendanceFilter
        filter={filter}
        onSearchChange={(newFilter) => setFilter(newFilter)}
        data={registrations}
        hasPermission={user?.role === "admin"}
        hasRefugeCeremony={event?.hasRefugeCeremony}
      />

      <EventAttendanceList
        data={registrations}
        loading={loading}
        filter={filter}
        pagination={pagination}
        onTableChange={handleTableChange}
        onCheckIn={handleCheckIn}
        checkInLoading={checkInManual.isPending}
        onStatusChange={handleStatusChange}
        onDelete={handleDelete}
        deleteLoading={deleteRegistration.isPending}
        user={user}
        event={event}
        onUpdateRegistrationCode={handleUpdateRegistrationCode}
        updateCodeLoading={false}
        onTakingRefugeChange={handleTakingRefugeChange}
        takingRefugeLoading={updateIsTakingRefuge.isPending}
      />

      <Modal
        title="Thêm người dùng vào sự kiện"
        open={addUserModalOpen}
        onCancel={() => setAddUserModalOpen(false)}
        footer={null}
      >
        <AddUserToEventModal
          eventId={eventId}
          event={event}
          onClose={() => setAddUserModalOpen(false)}
          adminAddUserToEvent={adminAddUserToEvent}
          onSuccess={refetch}
        />
      </Modal>
    </div>
  );
}
